import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { AppState } from '../../../app/store/rootReducers';
import OrderItemSection from './order-items-section';
import { resolveConflictAction } from "../../../app/store/order/basic/actions";
import { getLabelsByLanguage } from '../../../utilites/util';
import './scss/cartConflict.scss';

type CardConflictContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class CardConflictContainer extends Component<CardConflictContainerProps, any> {

  handleOnResolveConflict(orderType: any, resolvingInProgress: boolean): void {
    if (!resolvingInProgress) {
      this.props.resolveConflictAction(orderType);
    }
  }

  render() {
    const { ui, cartConflictData, resolvingInProgress } = this.props;
    const labels = getLabelsByLanguage();

    const getCartConflictMessage = (resolvingInProgress: boolean): string => {
      return resolvingInProgress ? labels.pleaseWait : labels.cartConflictMessage;
    };

    return (
      !ui.loading && cartConflictData.conflictExists ?
        <div className={'cart-conflict'}>
          <Modal className={'cart-conflict-popup ws-modal'} size='lg' centered show={cartConflictData.conflictExists}>
            <Modal.Body>
              <div className={'container'}>
                <div className={'text-center pt-4'}>
                  <span>{getCartConflictMessage(resolvingInProgress)}</span>
                </div>
                <div className={'row mx-auto pt-3'}>
                  <div className={'option col-md-12 col-lg-6 text-center'}>
                    <OrderItemSection
                      orderItem={cartConflictData.cookieOrderItems[0]}
                      cancelUrl={cartConflictData.cancelAccountOrderUrl}
                      labelButton={labels.continueWithOldOrder}
                      labelWithTariffPackage={labels.withTariffPackage}
                      labelSimOnlyCard={labels.simOnlyCard}
                      buttonStyle={resolvingInProgress ? 'btn-blue-yettel--disabled' : 'btn-blue-yettel'}
                      handleOnClick={this.handleOnResolveConflict.bind(this, 'cookieOrder', resolvingInProgress)}
                    />
                    <div className={'circle'}>
                      <span>
                        {resolvingInProgress ? <span className={'conflict-spinner'}></span> : labels.or}
                      </span>
                    </div>
                  </div>
                  <div className={'option col-md-12 col-lg-6 text-center'}>
                    <OrderItemSection
                      orderItem={cartConflictData.accountOrderItems[0]}
                      cancelUrl={cartConflictData.cancelCookieOrderUrl}
                      labelButton={labels.continueWithNewOrder}
                      labelWithTariffPackage={labels.withTariffPackage}
                      labelSimOnlyCard={labels.simOnlyCard}
                      buttonStyle={resolvingInProgress ? 'btn-blue-yettel--disabled' : 'btn-blue-yettel'}
                      handleOnClick={this.handleOnResolveConflict.bind(this, 'accountOrder', resolvingInProgress)}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div> : null
    );
  }

}

const mapStateToProps = (state: AppState) => {
  return {
    ui: state.ui,
    cartConflictData: state.order.cartConflictData,
    resolvingInProgress: state.order.resolvingInProgress
  };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    resolveConflictAction
  }, dispatch
);

export default (connect(
  mapStateToProps,
  mapDispatchToProps,
)(CardConflictContainer));
